module.exports = __webpack_public_path__ + "media/images/favicons/mstile-310x150-7a436cecac0e849aee4409938ae3d06d.png";